import { Fragment } from 'react';
import styled from 'styled-components';

import Bead from './Bead';

const Beads = ({ beadStates }) => (
  <BeadWrapper>
    {/* Draw bead for each phase */}
    {beadStates.map((state, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Fragment key={i}>
        <Bead state={state} i={i + 1} />
        {/* Draw line if not at the last bead */}
        {i < beadStates.length - 1 ? <Line /> : null}
      </Fragment>
    ))}
  </BeadWrapper>
);

const BeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Line = styled.div`
  width: 8px;
  border: 1px;
  border-style: solid;
  border-color: black;
`;

export default Beads;
